module.exports = __webpack_public_path__ + "img/notepad.9086924f.svg";